const RECOVERY_STORAGE_KEY = "bb-dw-password-recovery";

/** Redirect target for Supabase password recovery emails (must be allowlisted in the project). */
export function passwordResetRedirectUrl(): string {
  return `${window.location.origin}/reset-password`;
}

/** True when the email link hash still indicates a recovery flow (before Supabase consumes it). */
export function hashIndicatesPasswordRecovery(): boolean {
  const hash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : window.location.hash;
  return new URLSearchParams(hash).get("type") === "recovery";
}

export function markPasswordRecoveryPending(): void {
  sessionStorage.setItem(RECOVERY_STORAGE_KEY, "1");
}

export function clearPasswordRecoveryPending(): void {
  sessionStorage.removeItem(RECOVERY_STORAGE_KEY);
}

export function isPasswordRecoveryPending(): boolean {
  return sessionStorage.getItem(RECOVERY_STORAGE_KEY) === "1";
}
